<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Import Data Pegawai
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Import Pegawai</h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <h6>Template File Excel untuk Import Pegawai</h6>
        <img :src="imageUrl" alt="Example image" class="template-import" />
        <br />
        <p>
          Mohon menyesuaikan file excel import pegawai sesuai dengan kriteria
          berikut:
        </p>
        <ul>
          <li>
            Nama kolom yang diterima adalah: <mark>nama</mark>,<mark>nik</mark>,
            <mark>alamat</mark>,<mark>telp</mark>,<mark>tempat lahir</mark>,
            <mark>tanggal lahir</mark>,<mark>tanggal mulai bekerja</mark> dan
            <mark>agama</mark>,
          </li>
          <li><mark>nama</mark>: kolom <strong>harus diisi</strong></li>
          <li>
            <mark>nik</mark>: kolom
            <strong>harus diisi dan berupa angka</strong>
          </li>
          <li><mark>alamat</mark>: kolom tidak harus diisi</li>
          <li><mark>telp</mark>: kolom tidak harus diisi</li>
          <li><mark>tempat lahir</mark>: kolom <strong>harus diisi</strong></li>
          <li>
            <mark>tanggal lahir</mark>: kolom
            <strong
              >harus diisi dengan format bulan/tanggal/tahun
              (02/12/1995)</strong
            >
          </li>
          <li>
            <mark>tanggal mulai bekerja</mark>: kolom
            <strong
              >harus diisi dengan format bulan/tanggal/tahun
              (02/12/1995)</strong
            >
          </li>
          <li>
            <mark>agama</mark>: kolom
            <strong
              >harus diisi dengan nilai (Hindu, Islam, Protestan, Katolik,
              Buddha, Khonghucu)</strong
            >
          </li>
        </ul>
        <dl class="row">
          <dt class="col-sm-4">
            Download sample file excel untuk import data pegawai:
          </dt>
          <dt class="col-sm-8">
            <DxButton
              icon="download"
              text="Download"
              ref="fileDownloader"
              @click="downloadSample"
              styling-mode="outlined"
            />
          </dt>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">Import file excel data pegawai</dt>
          <dt class="col-sm-8">
            <input type="file" ref="fileInput" @change="handleFile" />
          </dt>
        </dl>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";
import { BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import * as XLSX from "xlsx";
import { DateTime } from "luxon";
import _ from "lodash";
import ODataStore from "devextreme/data/odata/store";
import axios from "axios";
export default {
  components: {
    DxButton,
  },
  data() {
    return {
      file: null,
      imageUrl: require("@/views/template_import_pegawai.png"),
      sampleUrl: `${BASE_URL}/files/import_template_pegawai.xlsx`,
      golonganSource: new ODataStore({
        url: `${ODATA_BASE_URL}/Golongans`,
        key: "id",
      }),
      jabatanSource: new ODataStore({
        url: `${ODATA_BASE_URL}/Jabatans`,
        key: "id",
      }),
      cabangSource: new ODataStore({
        url: `${ODATA_BASE_URL}/Cabangs`,
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: `${ODATA_BASE_URL}/Bagians`,
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: `${ODATA_BASE_URL}/SubBagians`,
        key: "id",
      }),
      subBidangSource: new ODataStore({
        url: `${ODATA_BASE_URL}/SubBidangs`,
        key: "id",
      }),
      seksiSource: new ODataStore({
        url: `${ODATA_BASE_URL}/Seksis`,
        key: "id",
      }),
      golongans: [],
      jabatans: [],
      cabangs: [],
      bagians: [],
      subBagians: [],
      subBidangs: [],
      seksis: [],
    };
  },
  mounted() {
    this.golonganSource.load().done((result) => {
      this.golongans = result;
    });
    this.jabatanSource.load().done((result) => {
      this.jabatans = result;
    });
    this.cabangSource.load().done((result) => {
      this.cabangs = result;
    });
    this.bagianSource.load().done((result) => {
      this.bagians = result;
    });
    this.subBagianSource.load().done((result) => {
      this.subBagians = result;
    });
    this.subBidangSource.load().done((result) => {
      this.subBidangs = result;
    });
    this.seksiSource.load().done((result) => {
      this.seksis = result;
    });
  },
  methods: {
    findSourceId(source, val) {
      var res = _.find(source, { nama: val });
      if (res === undefined) return null;
      return res.id;
    },
    prepareAxios(data) {
      console.log("dataasli");
      console.log(data);

      data.forEach((item) => {
        //perbaiki tgl
        //perbaiki id
        item.golongan_id = this.findSourceId(this.golongans, item.golongan_id);
        item.jabatan_id = this.findSourceId(this.jabatans, item.jabatan_id);
        item.cabang_id = this.findSourceId(this.cabangs, item.cabang_id);
        item.bagian_id = this.findSourceId(this.bagians, item.bagian_id);
        item.sub_bagian_id = this.findSourceId(
          this.subBagians,
          item.sub_bagian_id
        );
        item.sub_bidang_id = this.findSourceId(
          this.subBidangs,
          item.sub_bidang_id
        );
        item.seksi_id = this.findSourceId(this.seksis, item.seksi_id);
        item.tgl_mulai_bekerja = dateValid(item.tgl_mulai_bekerja);
      });

      console.log(data);
      return data;
    },

    downloadSample() {
      window.open(this.sampleUrl, "_blank");
    },

    async handleFile(e) {
      // console.log(_.find(this.seksis, { id: 1 }));
      const files = e.target.files;
      const file = files[0];
      this.file = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: "binary",
          cellText: false,
          cellDates: true,
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        // this.data = XLSX.utils.sheet_to_json(worksheet);
        this.data = XLSX.utils.sheet_to_json(worksheet, {
          // header: 1,
          raw: false,
          dateNF: 'dd"/"mm"/"yyyy',
        });

        this.uploadAxios(this.prepareAxios(this.data));
      };

      reader.readAsBinaryString(file);
    },

    uploadAxios: function (data) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      axios
        .post(`${API_BASE_URL}/simpeg_pegawai_import_final`, data, config)
        .then(function (res) {
          console.log(res);
          notify("Import data pegawai berhasil", "success");
        })
        .catch(function (err) {
          notify(
            "Import data pegawai gagal: " + err.response.data.message,
            "error"
          );
          console.log(err);
          // this.output = err;
        });
    },
  },
};

function dateValid(date) {
  let tgl = DateTime.fromFormat(date, "dd/mm/yyyy");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "dd-mm-yyyy");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "YYYY-mm-dd");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "YYYY-mm-dd");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "YYYY-LL-dd");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  return date;
}

// function prepareID(source, key) {
//   let find = _.find(source, { val: key });
//   if (_.isUndefined(find)) return "";
//   return find.id;
// }
</script>
<style>
.template-import {
  width: 1200px;
  height: auto;
  padding-bottom: 40px;
}
</style>
